import URLS from '../config/urls';
import BaseAPI from './BaseApi';

class OrderBonusApi {
    async getList(params: any): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.ORDERS}/search/bonus`, { params });
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async updateStatusBonus(orderUuid: string, status: any): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.ORDERS}/${orderUuid}/bonus?bonusStatus=${status}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao atualizar status" }; // Retorna um objeto de erro
        }
    }
}

const orderBonusApi = new OrderBonusApi();
export default orderBonusApi;